<template>
  <div>
    <router-view v-if="planDeCuentas.length" :planDeCuentas="planDeCuentas" />
    <v-row v-else justify="center">
      <v-col cols="12" md="10">
        <v-list>
          <v-skeleton-loader max-height="350" type="list-item"></v-skeleton-loader>
        </v-list>
      </v-col>
      <v-col cols="12" md="10">
        <v-list>
          <v-skeleton-loader
            v-for="i in 6"
            :key="i"
            max-height="350"
            type="list-item-avatar"
          ></v-skeleton-loader>
        </v-list>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "SucursalContabilidad",
  data() {
    return {
      sucursalNoConfigurada: false,
      registrando: false,
    };
  },
  computed: {
    ...mapState("contabilidad", ["planDeCuentas"]),
  },
  methods: {
    ...mapActions("contabilidad", ["fetchPlanDeCuentas"]),
    async fetchCuentas() {
      try {
        await this.fetchPlanDeCuentas({ empresaUuid: null, isActive: true });
      } catch (error) {
        const detail = error?.response?.data?.detail || "";
        if (detail === "SucursalContable not found.") {
          this.sucursalNoConfigurada = true;
          return;
        }
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "info",
          text: "Error al obtener el plan de cuentas",
          icon: "mdi-information",
          timeout: 3000,
        });
      }
    },
   
  },
  created() {
    this.fetchCuentas();
  },
};
</script>

<style lang="scss" scoped>
</style>
